// src/utils/leadStatusOptions.js
import api from "../axiosConfig";

export const getLeadStatusOptions = () =>
  api.get("/contacts/lead-status-options").then((res) => {
    // backend returns: { options: [{ value, label }, ...] }
    return res?.data?.options || [];
  });

export const labelFor = (options, value) => {
  const v = String(value ?? "");
  const opt = (options || []).find((o) => String(o.value) === v);
  return opt?.label || v || "—";
};
